import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { MessageRetailerOrBrandButton } from "../../shared/instantAnswerUtils";
import { countryToISO } from "../../utils/countryToISO";
import { getShipFromCountryForOrder } from "../../utils/getShipFromCountryForOrder";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";
export var HowShippingWorks = function HowShippingWorks(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var _getShipFromCountryFo;
  var shipFromCountry = (_getShipFromCountryFo = getShipFromCountryForOrder(context)) !== null && _getShipFromCountryFo !== void 0 ? _getShipFromCountryFo : getShipFromCountryForBrand(context.brand);
  var shipFromCountryISO = countryToISO(shipFromCountry);
  return isSWFAvailableInCountry(shipFromCountryISO) ? SwfAvailableScenario(strictLocalize) : SwfNotAvailableScenario(strictLocalize);
};
var SwfAvailableScenario = function SwfAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize), OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize), OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize)];
    }
  };
};
var SwfNotAvailableScenario = function SwfNotAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize)];
    }
  };
};
var SHIPPING_OPTIONS = function SHIPPING_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "UGEH5X",
    defaultMessage: "Shipping options"
  });
};
var OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE = function OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize) {
  return strictLocalize({
    id: "cITe5h",
    defaultMessage: "When you are ready to ship your order, you can choose to Ship with Faire or Ship on your own."
  });
};
var YOU_CAN_USE_YOUR_OWN_CARRIER = function YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize) {
  return strictLocalize({
    id: "ctr/F1",
    defaultMessage: "When you’re ready to ship your order, you can use your own carrier to ship this order — just enter the shipping cost and tracking number in our system once it’s available, and we’ll reimburse you for the shipping cost in your total order payout."
  });
};
var OLD_SHIP_WITH_FAIRE_DEFINITION = function OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "pgJwpA",
    defaultMessage: "Ship with Faire allows you to print your shipping labels through Faire to receive low carrier rates while paying zero shipping fees. We will automatically record the shipping cost and tracking number from the shipment to help save you time!"
  });
};
var OLD_SHIP_ON_YOUR_OWN_DEFINITION = function OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "FAgUqw",
    defaultMessage: "Ship on your own allows you to handle the shipment yourself. You can use your own carrier to ship this order — just enter the shipping cost and tracking number in our system once it’s available, and we’ll reimburse you for the shipping cost in your total order payout."
  });
};